import { t } from '@/lib/i18n';
import { usePermission } from '@/stores/auth';
import { LlmKeysSection } from '../components/LlmKeysSection';
import { ConnectorsSection } from '@/features/connectors';
import styles from './SettingsPage.module.css';

export default function SettingsPage() {
  const canManageLlm = usePermission('manage_tenant_llm_config');
  const canManageConnectors = usePermission('manage_connector_configs');
  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <h1 className={styles.title}>{t('Settings')}</h1>
        <p className={styles.subtitle}>
          {t('Manage workspace-level configuration for your team.')}
        </p>
      </header>

      <section className={styles.section}>
        {canManageLlm ? (
          <LlmKeysSection />
        ) : (
          <p className={styles.gated}>
            {t('Workspace owner permission required to manage LLM keys.')}
          </p>
        )}
      </section>

      {canManageConnectors && (
        <section className={styles.section}>
          <ConnectorsSection />
        </section>
      )}
    </div>
  );
}
